import { Injectable } from '@angular/core';
import { Store, guid } from '@datorama/akita';

export interface MeetingAlternativeDialogState {
	notificationId: string;
}

@Injectable()
export class MeetingAlternativeDialogStore extends Store<MeetingAlternativeDialogState> {
	constructor() {
		super({}, { name: `ui-meeting-alternative-dialog-${guid()}` });
	}
}
